<template>
    <v-menu
        :close-on-content-click="false"
        :left="!landscape"
        transition="scale-transition"
    >
        <template v-slot:activator="{ on }">
            <v-text-field v-on="on"
                          prepend-icon="event"
                          :value="formatDate(dateClone)"
                          readonly
            />
        </template>
        <v-date-picker v-if="!disabled"
                       v-model="dateClone"
                       :max="maxDate"
                       :min="minDate"
                       :landscape="landscape"
                       :locale="$i18n.locale"
        />
    </v-menu>
</template>

<script>
import isEmpty from 'lodash/isEmpty';

import DateTimeUtil from '../../util/date-time-util';

export default {
  name: 'TimePairDatePicker',
  props: {
    disabled: Boolean,
    timeEntry: {
      type: Object,
      required: true,
    },
    max: String,
    min: String,
  },

  data() {
    return {
      dateClone: {},
    };
  },

  methods: {
    formatDate(date) {
      return DateTimeUtil.convertToHumanReadableDate(date);
    },

    resetDate() {
      this.dateClone = DateTimeUtil.convertDateTimeToDate(this.timeEntry.date);
    },
  },

  computed: {
    maxDate() {
      if (!isEmpty(this.max)) return DateTimeUtil.convertDateTimeToDate(this.max);
      return DateTimeUtil.convertDateTimeToDate(new Date());
    },

    minDate() {
      const previousPayCycleDate = DateTimeUtil.convertDateTimeToDate(DateTimeUtil.getStartOfPreviousPayCycle());

      if (!isEmpty(this.min)) {
        const minDate = DateTimeUtil.convertDateTimeToDate(this.min);

        if (minDate > previousPayCycleDate) {
          return minDate;
        }
      }

      return previousPayCycleDate;
    },

    landscape() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return false;
        default: return true;
      }
    },
  },

  watch: {
    timeEntry() {
      this.resetDate();
    },

    dateClone(value) {
      this.$emit('update', { entryType: this.timeEntry.entryType, newDate: value });
    },
  },

  created() {
    this.resetDate();
  },
};
</script>
